export const levels = [
  {
    id: "UG",
    name: "Under Graduate",
  },
  {
    id: "PG",
    name: "Post Graduate",
  },
  {
    id: "Doctorate",
    name: "Doctorate",
  },
  {
    id: "Diploma",
    name: "Diploma",
  },
  {
    id: "PG Diploma",
    name: "PG Diploma",
  },
];

export const durations = [
  {
    id: "S",
    name: "Semester",
  },
  {
    id: "Y",
    name: "Year",
  },
];

export const pst_types = [
  {
    id: "Core",
    name: "Core",
  },
  {
    id: "Elective",
    name: "Elective",
  },
];

export const feeTypes = [
  {
    value: "Term Fee",
    text: "Term Fee",
  },
  {
    value: "Annual",
    text: "Annual Upfront",
  },
  {
    value: "Full",
    text: "Full Upfront",
  },
];

export const roles = [
  { id: "Admin", name: "Admin" },
  { id: "Reviewer", name: "Reviewer" },
  { id: "Partner", name: "Partner" },
  { id: "Coordinator", name: "Coordinator" },
  { id: "CFO", name: "CFO" },
  { id: "Management", name: "Management" },
  { id: "Business", name: "Business" },
  { id: "Business Reviewer", name: "Business Reviewer" },
  { id: "Document Viewer", name: "Document Viewer" },
  { id: "Approver", name: "Approver" },
  { id: "COE", name: "COE" },
  { id: "Verifier", name: "Verifier" },
  { id: "Attendance Verifier", name: "Attendance Verifier" },
];
